import * as React from "react";
function SvgIcon2(props) {
  return <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 33 33.045" {...props}><path d="M32.498 16.521L18.198.843a.99.99 0 00-1.7.774v9.055H2.719a2.336 2.336 0 00-2.221 2.437v6.823a2.336 2.336 0 002.221 2.437h13.779v9.055a.99.99 0 001.7.774z" fill="none" stroke="#7b7b7b" strokeLinecap="round" strokeLinejoin="round" /></svg>;
}
export default SvgIcon2;